export var RequestCode;
(function (RequestCode) {
    RequestCode[RequestCode["SUCCESS"] = 0] = "SUCCESS";
    // 操作过快
    RequestCode[RequestCode["OPERATION_TOO_SOONG"] = 101] = "OPERATION_TOO_SOONG";
    // 账号相关
    // 无账号
    RequestCode[RequestCode["NO_ACCOUNT"] = 1000] = "NO_ACCOUNT";
    // 无角色
    RequestCode[RequestCode["NO_ROLE"] = 1001] = "NO_ROLE";
    RequestCode[RequestCode["USER_INITIAL_FAILED"] = 1011] = "USER_INITIAL_FAILED";
    RequestCode[RequestCode["USER_BRIEF_FAILED"] = 1002] = "USER_BRIEF_FAILED";
    RequestCode[RequestCode["USER_STAT_FAILED"] = 1003] = "USER_STAT_FAILED";
    // 找不到活动
    RequestCode[RequestCode["ACTIVITY_NOT_FOUND"] = 2000] = "ACTIVITY_NOT_FOUND";
    // 活动未开始
    RequestCode[RequestCode["ACTIVITY_NOT_START"] = 2002] = "ACTIVITY_NOT_START";
    // 活动已结束
    RequestCode[RequestCode["ACTIVITY_ENDED"] = 2003] = "ACTIVITY_ENDED";
    // 找不到任务
    RequestCode[RequestCode["TASK_NOT_FOUND"] = 2100] = "TASK_NOT_FOUND";
    // 找不到用户任务
    RequestCode[RequestCode["TASK_NOT_CLAIM"] = 2101] = "TASK_NOT_CLAIM";
    // 用户任务无法完成
    RequestCode[RequestCode["TASK_CANT_COMPLETE"] = 2102] = "TASK_CANT_COMPLETE";
    // 活动参与等级不足
    RequestCode[RequestCode["ACTIVITY_CHECKER_LEVEL_TOO_LOW"] = 2208] = "ACTIVITY_CHECKER_LEVEL_TOO_LOW";
    // 活动参与等级过高
    RequestCode[RequestCode["ACTIVITY_CHECKER_LEVEL_TOO_HIGH"] = 2209] = "ACTIVITY_CHECKER_LEVEL_TOO_HIGH";
    // 找不到用户收集
    RequestCode[RequestCode["COLLECTION_NOT_FOUND"] = 2301] = "COLLECTION_NOT_FOUND";
    // 找不到用户分数
    RequestCode[RequestCode["SCORE_NOT_FOUND"] = 2401] = "SCORE_NOT_FOUND";
    // 找不到指定队伍
    RequestCode[RequestCode["TEAM_NOT_FOUND"] = 3000] = "TEAM_NOT_FOUND";
    // 无法加入自己创建的队伍
    RequestCode[RequestCode["TEAM_CANT_JOIN_OWN"] = 3001] = "TEAM_CANT_JOIN_OWN";
    // 队伍内已经存在其他队员了
    RequestCode[RequestCode["TEAM_HAS_MEMBER_ALREADY"] = 3002] = "TEAM_HAS_MEMBER_ALREADY";
    // 已经加入了这个队伍
    RequestCode[RequestCode["TEAM_JOIN_ALREADY"] = 3003] = "TEAM_JOIN_ALREADY";
    // 只有召回用户才可以加入队伍
    RequestCode[RequestCode["TEAM_RECALL_PLAYER_ONLY"] = 3050] = "TEAM_RECALL_PLAYER_ONLY";
    // 只有召回用户或者新用户才可以加入队伍
    RequestCode[RequestCode["TEAM_RECALL_OR_NEW_PLAYER_ONLY"] = 3051] = "TEAM_RECALL_OR_NEW_PLAYER_ONLY";
    // 尝试抽奖无剩余抽奖券
    RequestCode[RequestCode["DRAW_NO_COUPON"] = 3101] = "DRAW_NO_COUPON";
    // 抽奖没有抽取结果
    RequestCode[RequestCode["DRAW_NO_RESULT"] = 3102] = "DRAW_NO_RESULT";
    // 抽奖没有抽取结果
    RequestCode[RequestCode["DRAW_CONTACT_FILL_ALREADY"] = 3110] = "DRAW_CONTACT_FILL_ALREADY";
    // 无需填写地址信息
    RequestCode[RequestCode["DRAW_CONTACT_FILL_INVALID"] = 3111] = "DRAW_CONTACT_FILL_INVALID";
    // 礼包服务 超出抽取限制
    RequestCode[RequestCode["GIFT_SERVICE_DRAW_EXCEED"] = 4001] = "GIFT_SERVICE_DRAW_EXCEED";
    // 礼包服务 超出单天抽取限制
    RequestCode[RequestCode["GIFT_SERVICE_DRAW_DAILY_EXCEED"] = 4002] = "GIFT_SERVICE_DRAW_DAILY_EXCEED";
    // 游戏数据服务
    // GAME_SERVICE_= 5001
    // 找不到游戏角色档案
    RequestCode[RequestCode["GAME_SERVICE_NO_ROLE_PROFILE"] = 5004] = "GAME_SERVICE_NO_ROLE_PROFILE";
    // 游戏数据服务
    RequestCode[RequestCode["GAME_SERVICE_STAT_NOT_FOUNT"] = 5104] = "GAME_SERVICE_STAT_NOT_FOUNT";
})(RequestCode || (RequestCode = {}));
